import { useNavigate } from "react-router-dom";
import ButtonGradient from "../../../components/ui/ButtonGradient";
import Description from "../../../components/ui/Description";
import TextArea from "../../../components/ui/TextArea";
import TitleStyles from "../../../components/ui/TitleStyles";
import { Container } from "./BiographyStyles";
import TooltipModal from "../../../components/tooltipModal/TooltipModal";
import { useState } from "react";
import ProgressBar from "../../../components/progressBar/ProgressBar";

const Biography = () => {
  const navigate = useNavigate();
  const [showTooltip, setShowTooltip] = useState(true);
  return (
    <Container>
      {showTooltip && (
        <TooltipModal
          onClose={() => setShowTooltip(false)}
          buttonLabel="Entendi"
        >
          <p>
            <strong>Personalize!</strong>
            <br />
            Todas as etapas são opcionais! Caso prefira, você pode pular
            clicando em <em>‘Próximo’</em>.<br />
            Mas não se preocupe, você pode voltar a qualquer momento.
          </p>
        </TooltipModal>
      )}
      <TitleStyles>Biografia</TitleStyles>
      <Description>Escreva sua biografia:</Description>
      <TextArea placeholder="Fale sobre você como artista..." rows={6} />
      <ProgressBar totalSteps={9} currentStep={0} />
      <ButtonGradient onClick={() => navigate("/music-sets")}>
        Próximo &gt;
      </ButtonGradient>
    </Container>
  );
};

export default Biography;
